module.exports = __webpack_public_path__ + "img/LapBoard.04405ce6.png";